import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './index.css';
import './assets/fonts/fonts.css';
import SVGViewer from './components/SVGViewer';
import ProtaPage from './components/ProtaPage';
import Impressum from './components/Impressum';
import Ereignisse from './components/Ereignisse';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<SVGViewer />} />
          <Route path="/person/:personId" element={<ProtaPage />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/ereignisse" element={<Ereignisse />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;